import { render, staticRenderFns } from "./Recruiters.vue?vue&type=template&id=28877508&scoped=true&"
import script from "./Recruiters.vue?vue&type=script&lang=js&"
export * from "./Recruiters.vue?vue&type=script&lang=js&"
import style0 from "./Recruiters.vue?vue&type=style&index=0&id=28877508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28877508",
  null
  
)

export default component.exports